import { observable, action } from 'mobx';

// lodash
import _get from 'lodash/get';
import _map from 'lodash/map';

import { mapInitialStateToStoreState } from '@tajawal/web-core-sdk-v2/lib/utils/store.utils';
import { $sessionStorage } from '@tajawal/web-core-sdk-v2/lib/services/session-storage.service';
import { $localStorage } from '@tajawal/web-core-sdk-v2/lib/services/local-storage.service';

import { LOCAL_STORAGE_KEYS, SESSION_STORAGE_KEYS } from '@/constants/cache.constants';

export default class UiStore {
  constructor(initialState = {}) {
    this.setPageLoading(false);
    this.setDashboardDrawerOpen(false);
    this.set12HoursTimeFormat($sessionStorage.get(SESSION_STORAGE_KEYS.IS_12_HOURS_TIME_FORMAT));
    this.setSaveCompareList($localStorage.get(LOCAL_STORAGE_KEYS.SAVE_COMPARE));
    this.setShowSavedSection(false);
    this.setIsSavedAction(false);
    this.setLastSavedItinerary(false);
    this.setFlightSubmitError(false);
    // @ts-ignore
    mapInitialStateToStoreState(initialState);
  }

  @observable isPageLoading = false;
  @observable isDashboardDrawerOpen = false;
  @observable errorsMap = {};
  @observable is12HoursTimeFormat = $sessionStorage.get(SESSION_STORAGE_KEYS.IS_12_HOURS_TIME_FORMAT);
  @observable saveCompareList = $localStorage.get(LOCAL_STORAGE_KEYS.SAVE_COMPARE);
  @observable isShowSavedSection = false;
  @observable lastSavedItinerary = false;
  @observable isSavedAction = false;
  @observable isFlightSubmitError = false;
  @observable isOutboundFareUpgraded = false;
  @observable isInboundFareUpgraded = false;

  setIsFareFamilyUpgraded = action((isUpgraded, isOutbound) => {
    if (isOutbound) {
      this.isOutboundFareUpgraded = isUpgraded;
    } else {
      this.isInboundFareUpgraded = isUpgraded;
    }
  });

  setPageLoading = action((isLoading) => {
    this.isPageLoading = isLoading;
  });

  setIsSavedAction = action((isSavedAction) => {
    this.isSavedAction = isSavedAction;
  });

  setDashboardDrawerOpen = action((isOpen) => {
    this.isDashboardDrawerOpen = isOpen;
  });

  set12HoursTimeFormat = action((is12HoursFormat) => {
    this.is12HoursTimeFormat = is12HoursFormat;
    $sessionStorage.set(SESSION_STORAGE_KEYS.IS_12_HOURS_TIME_FORMAT, is12HoursFormat);
  });

  setShowSavedSection = action((isOpen) => {
    this.isShowSavedSection = isOpen;
  });

  setLastSavedItinerary = action((itinerary) => {
    this.lastSavedItinerary = itinerary;
  });

  setFlightSubmitError = action((error) => {
    this.isFlightSubmitError = error;
  });

  setSaveCompareList = action((saveCompareList) => {
    this.saveCompareList = saveCompareList;
    $localStorage.set(LOCAL_STORAGE_KEYS.SAVE_COMPARE, saveCompareList);
  });

  setError = action((error) => {
    this.errorsMap = { ...this.errorsMap, [error]: true };
  });

  getError = action((error) => {
    return _get(this.errorsMap, error, false);
  });

  getErrors = action((errors) => {
    return _map(errors, this.getError);
  });

  resetErrors = action(() => {
    this.errorsMap = {};
  });
}
